/*
 * "Address" : {
 *   "required" : ["street", "streetNumber", "zipCode", "city"],
 *   "type" : "object",
 *   "properties" : {
 *     "street" : {
 *       "description" : "Straße",
 *       "type" : "string"
 *     },
 *     "streetNumber" : {
 *       "description" : "Türnummer",
 *       "type" : "string"
 *     },
 *     "zipCode" : {
 *       "description" : "Postleitzahl",
 *       "type" : "string"
 *     },
 *     "city" : {
 *       "description" : "Stadt",
 *       "type" : "string"
 *     }
 *   }
 * },
 */

import { isNullOrUndefined } from "../utils";

export class Address {
  constructor(
    public street: string,
    public streetNumber: string,
    public zipCode: string,
    public city: string,
  ) {
  }

  public static fromJSON(json: {
    street: string,
    streetNumber: string,
    zipCode: string,
    city: string,
  }): Address {
    if (!json) {
      throw new Error('Address JSON should not be undefined');
    }
    if (isNullOrUndefined(json.street)) {
      throw new Error('Address JSON should have property: street');
    }
    if (isNullOrUndefined(json.streetNumber)) {
      throw new Error('Address JSON should have property: streetNumber');
    }
    if (isNullOrUndefined(json.zipCode)) {
      throw new Error('Address JSON should have property: zipCode');
    }
    if (isNullOrUndefined(json.city)) {
      throw new Error('Address JSON should have property: city');
    }

    return new Address(
      json.street,
      json.streetNumber,
      json.zipCode,
      json.city,
    );
  }
}
